// extracted by mini-css-extract-plugin
export default {"section":"section_section__ynClH","sectionContainer":"section_sectionContainer__BhnUc","row":"section_row__QDBOO"};